import { Component, ContentChildren, EventEmitter, Input, Output, QueryList, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'editable-tooltip',
    templateUrl: './editable-tooltip.component.html',
    styleUrls: ['./editable-tooltip.component.scss'],
    standalone: false
})
export class EditableTooltipComponent {

  @ViewChild(NgbTooltip) tooltip: NgbTooltip;

  @ContentChildren(NgModel, { descendants: true }) controls: QueryList<NgModel>;

  @Input()
  isReadOnly: boolean = false;

  @Input()
  isLoading: boolean = false;

  @Output()
  open = new EventEmitter<any>();

  @Output()
  save = new EventEmitter<any>();

  @Output()
  close = new EventEmitter<any>();

  onOpen() {
    this.open.emit(this);
  }

  onSave() {
    this.save.emit(this);
  }

  onClose() {
    this.closeTooltip();
  }

  closeTooltip() {
    this.tooltip.close();
    this.close.emit();
  }
}
